@let _key = key();

<button
  [class]="twClasses()"
  [disabled]="disabled()"
  [animate.enter]="disabled() || !animateEnter() ? '' : 'anim-pop-in'"
  (click)="press()"
>
  @if (_key.type === 'KLANKVOET') {
    @switch (_key.value) {
      @case ('>') {
        <i-klankvoet-normal class="size-[1lh]" />
      }
      @case ('<') {
        <i-klankvoet-stom class="size-[1lh]" />
      }
    }
  } @else {
    {{ getDisplayText(_key) }}
  }
</button>
